<section style="padding:10px 20px">
    <div class="sedc contShadow sMbdrRad">
        <div *ngIf="!status" style="padding: 5px;" class="flex">
            <div style="flex:1;">
                <ul style="padding-top:2em;">
                    <li>
                        <button mat-button class="active" *ngIf="open">Travel Info</button>
                        <button mat-button *ngIf="!open" (click)="set1()">Travel Info</button>
                    </li>
                    <li>
                        <button mat-button class="active" *ngIf="!open">Holder Info</button>
                        <button mat-button *ngIf="open" (click)="set2()">Holder Info</button>
                    </li>

                </ul>
            </div>
            <div style="flex:6;">

                <!-- <div *ngIf="edit" class="flex" style="justify-content: end;">
                    <button *ngFor="let p of persons" mat-button>{{p.firstname}}</button>
                </div> -->
                <div id="trvlInfo" *ngIf="open">
                    <div>
                        <br>
                        <div class="flex" style="justify-content: space-between;">
                            <b style="color:var(--primary-color)">Travel Information</b>
                        </div>
                        <br>
                        <hr>
                        <br>

                    </div>
                    <div>
                        <form [formGroup]="policyForm" style="align-items: start;" class="flex">
                            <div style="flex:1;">
                                <mat-form-field style="width: 87%">
                                    <mat-label>Select Package</mat-label>
                                    <mat-select (selectionChange)="onSelection($event)" (selectionChange)="chr($event)"
                                        (selectionChange)="getCountry()" formControlName="package" placeholder="">
                                          <mat-option *ngFor="let pkg of pkgs" value="{{pkg._id}}">{{pkg.categoryName}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <br>
                                <!-- <mat-form-field style="width: 87%">
                                    <mat-label>Purpose of Travel</mat-label>
                                    <textarea  (keyup)="chr($event)" matInput placeholder="" formControlName="purposeOfTravel"></textarea>
                                </mat-form-field> -->

                            </div>
                            <div style="flex:1;" *ngIf="student">
                                <mat-form-field style="width: 87%">
                                    <mat-label>Select Plan</mat-label>
                                    <mat-select (selectionChange)="chr($event)" formControlName="package"
                                        placeholder="">
                                        <mat-option *ngFor="let plan of PLANS" value="{{plan}}">{{plan}}</mat-option>

                                    </mat-select>
                                </mat-form-field>
                                <br>
                                <mat-form-field style="width: 87%">
                                    <mat-label>Select Coverage</mat-label>
                                    <mat-select (selectionChange)="chr($event)" formControlName="payment_plan"
                                        placeholder="">
                                        <mat-option value="Worldwide_1">Worldwide_1</mat-option>
                                        <mat-option value="Worldwide">Worldwide</mat-option>

                                    </mat-select>
                                </mat-form-field>

                            </div>
                            <div style="flex:1;">
                                <mat-form-field style="width: 87%">
                                    <mat-label>Destination</mat-label>
                                    <mat-select (selectionChange)="chr($event)" formControlName="country_id">
                                            <input class="mat-mdc-option" placeholder="Search Countries" style="cursor: text; width: 100%;"
                                                type="search" name="search" matRipple (keyup)="searchInput(search.value)" #search>
                                                                                       <mat-option *ngFor="let country of countriesQueue"  value="{{country._id}}">{{country.countryName}}</mat-option>

                                    </mat-select>
                                </mat-form-field>

                            </div>
                            <div style="flex:1;">

                                <!-- <mat-form-field style="width: 87%">
                                    <mat-label>Number Of Persons</mat-label>
                                    <input type="number"  (keyup)="chr($event)"  formControlName="numberOfPeople" name="" #numberOfPeople id=""
                                        matInput>
                                </mat-form-field>
                                <mat-form-field style="width: 87%">
                                    <mat-label>Number Of Minors</mat-label>
                                    <input type="number" (keyup)="chr($event)" formControlName="numberOfMinor"
                                        [max]="maxMinor()" name="" id="" matInput>
                                    <mat-error *ngIf="policyForm.controls.numberOfMinor.errors">Number of Minors must be
                                        one less than number of persons</mat-error>
                                </mat-form-field> -->

                                <!-- <br> -->
                                <div id="sd">
                                    <!-- <p>Insurance Period</p>
                                    <br> -->
                                    <div class="flex" style="gap: 5px;">
                                        <mat-form-field>
                                            <mat-label>Start</mat-label>
                                            <input formControlName="startDate" (click)="calcNoDays()"
                                                (dateChange)="chr($event)" [min]="minDate2" matInput
                                                [matDatepicker]="pickerStart">
                                            <mat-hint>MM/DD/YYYY</mat-hint>
                                            <mat-datepicker-toggle matIconSuffix
                                                [for]="pickerStart"></mat-datepicker-toggle>
                                            <mat-datepicker #pickerStart></mat-datepicker>
                                        </mat-form-field>
                                        <mat-form-field
                                            *ngIf="policyForm.get('startDate')?.touched || policyForm.get('startDate')?.valid ">
                                            <mat-label>End</mat-label>
                                            <input formControlName="endDate" (dateChange)="chrsd()"
                                                [disabled]="!policyForm.get('startDate')?.valid" [min]="minDate"
                                                matInput [matDatepicker]="pickerEnd">
                                            <mat-hint>MM/DD/YYYY</mat-hint>
                                            <mat-datepicker-toggle matIconSuffix (blur)="chrsd()"
                                                [for]="pickerEnd"></mat-datepicker-toggle>
                                            <mat-datepicker #pickerEnd></mat-datepicker>
                                        </mat-form-field>
                                    </div>

                                </div>
                            </div>

                            <!-- <div></div> -->
                        </form>
                        <div class="days" *ngIf="noOfDays>0">
                            Duration:
                            <h2> {{noOfDays}} days </h2>
                        </div>
                        <div class="flex pad" style="padding-bottom: 2em; justify-content: end; gap: 1rem;">
                            <button mat-flat-button [disabled]="!btnChkr" (click)="set2()" color="accent">
                                <mat-icon class="mat-18">arrow_forward</mat-icon>
                                Next</button>
                        </div>

                        <!-- <div>
                        </div> -->
                    </div>
                </div>
                <div id="hldrInfo" *ngIf="!open">
                    <div>
                        <br>
                        <b style="color:var(--primary-color)">Holder Information</b>
                        <br>
                        <hr>
                        <br>

                    </div>
                    <div>
                        <form [formGroup]="policyForm" class="flex holder-info-form"
                            style="align-items: start; gap:5px;">
                            <div class="holder-info">
                                <mat-form-field>
                                    <mat-label>First Name</mat-label>
                                    <input type="text" formControlName="firstname" matInput>
                                </mat-form-field>

                                <mat-form-field>
                                    <mat-label>Other Name</mat-label>
                                    <input type="text" formControlName="othername" id="" matInput>
                                </mat-form-field>

                                <mat-form-field>
                                    <mat-label>Last Name</mat-label>
                                    <input type="text" formControlName="surname" matInput>
                                </mat-form-field>

                                <mat-form-field>
                                    <mat-label>Email</mat-label>
                                    <input type="email" formControlName="email" id="" matInput>
                                </mat-form-field>

                                <!-- <mat-form-field>
                                    <mat-label>Health Status</mat-label>
                                    <input type="tel" formControlName="helthstatus" id="" matInput>
                                </mat-form-field> -->

                            </div>
                            <div class="holder-info">
                                <mat-form-field>
                                    <mat-label>Gender</mat-label>
                                    <mat-select formControlName="gender" placeholder="">
                                        <mat-option value="M">Male</mat-option>
                                        <mat-option value="F">Female</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>Phone Number</mat-label>
                                    <input type="tel" formControlName="phone" name="" id="" matInput>

                                    <mat-error *ngIf="policyForm.controls.phone.errors">use the format
                                        07057537572</mat-error>
                                </mat-form-field>

                                <mat-form-field>
                                    <mat-label>DOB</mat-label>
                                    <input formControlName="dob" matInput [max]="minDate2" [matDatepicker]="picker">
                                    <mat-hint>MM/DD/YYYY</mat-hint>
                                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>Address</mat-label>
                                    <textarea matInput placeholder="" formControlName="address"></textarea>
                                </mat-form-field>
                            </div>
                            <div class="holder-info">
                                <mat-form-field>
                                    <mat-label>Passport No.</mat-label>
                                    <input type="text" #passportInput formControlName="passportNo" matInput>
                                    <mat-error *ngIf="policyForm.controls.passportNo.errors">Enter a valid passport
                                        number: e.g 'A12345678'</mat-error>
                                </mat-form-field>

                                <mat-form-field>
                                    <mat-label>Passport Issue Date</mat-label>
                                    <input formControlName="passportIssueDate" 
                                        matInput [matDatepicker]="pickerPassDate1">
                                    <mat-hint>MM/DD/YYYY</mat-hint>
                                    <mat-datepicker-toggle matIconSuffix
                                        [for]="pickerPassDate1"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerPassDate1></mat-datepicker>
                                </mat-form-field>

                                <mat-form-field>
                                    <mat-label>Passport Expiry Date</mat-label>
                                    <input formControlName="passportExpiryDate"
                                        matInput [matDatepicker]="pickerPassDate2">
                                    <mat-hint>MM/DD/YYYY</mat-hint>
                                    <mat-datepicker-toggle matIconSuffix
                                        [for]="pickerPassDate2"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerPassDate2></mat-datepicker>
                                </mat-form-field>

                                <div>
                                    <label class="custom-file-upload">
                                        <input type="file" accept="application/pdf, .jpg,.png,.jpeg" (change)="passportImage($event)"/>
                                        <mat-icon *ngIf="!file" style="color: rgb(249, 182, 182);">cloud_upload</mat-icon>
                                        <mat-icon *ngIf="file" style="color: var(--primary-color);">cloud_done</mat-icon>
                                        <div class="upload-text">
                                            <p>Upload Passport Data Page</p>
                                            <p style="color: rgb(95, 95, 249); text-align: center;">{{file?.name}}</p>
                                        </div>
                                        
                                    </label>
                                </div>                              
                            <!-- 
                                <mat-form-field>
                                    <mat-label>Upload Data Page</mat-label>
                                    <input type="text" formControlName="nextOfKinName" id="" matInput>
                                </mat-form-field> -->
                            </div>

                            <div class="holder-info">
                                <mat-form-field>
                                    <mat-label>Next of Kin</mat-label>
                                    <input type="text" formControlName="nextOfKinName" id="" matInput>
                                </mat-form-field>

                                <mat-form-field>
                                    <mat-label>Relationship with Next of Kin</mat-label>
                                    <mat-select formControlName="relation" placeholder="">
                                        <mat-option
                                        *ngFor="let relationship of relationships | keyvalue"
                                        [value]="relationship.value"
                                        >{{ relationship.value }}
                                      </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field *ngIf="policyForm.controls.relation.value == 'Others'">
                                    <mat-label>kindly State Relationship</mat-label>
                                    <input type="text" formControlName="relationa" value="" name="" id="" matInput>
                                </mat-form-field>

                                <mat-form-field>
                                    <mat-label>Region</mat-label>
                                    <mat-select formControlName="region">
                                      <mat-option
                                        *ngFor="let region of regions | keyvalue"
                                        [value]="region.value"
                                        >{{ region.value }}
                                      </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <div *ngIf="!(policyForm.controls.relation.value == 'Others')">

                                </div>
                            </div>

                        </form>
                        <div class="flex pad" style="justify-content: end;">
                            <button mat-stroked-button (click)="set1()" style="margin-right: 10px;">
                                <!-- <mat-icon>arrow_left</mat-icon> -->
                                Back</button>
                            <button mat-flat-button (click)="addNew()" [disabled]="!policyForm.valid" color="accent">
                                <ng-container *ngIf="persons.length <= 0"> Add a Traveler</ng-container>
                                <ng-container *ngIf="persons.length > 0"> Add a new Traveler</ng-container>
                            </button>
                            <!-- <button mat-stroked-button color="accent" (click)="set2()">Back</button> -->
                            <!-- <button style="margin-left: 20px;" mat-flat-button color="accent"
                                (click)="preview()">Preview</button> -->
                        </div><br>
                    </div>

                    <div *ngIf="persons.length > 0">
                        <div>
                            <div class="flex" style="justify-content: space-between;">

                                <h3 style="font-size: 15px;">All Travelers</h3>
                                <div class="flex">
                                    <p>Total Premium</p>
                                    <h3 style="font-size: 15px;
                                    margin-left: 10px;">{{grossDetail['grossPremium'] | currency:'₦ '}}</h3>
                                </div>
                            </div>
                            <table class="sMbdrRad">
                                <tr>
                                    <th>Name</th>
                                    <th>contact</th>
                                    <th>Email</th>
                                    <th>DOB</th>
                                    <!-- <th>Gender</th> -->
                                    <th>Passport NO.</th>
                                    <th>Age</th>
                                    <th>Individual Price</th>
                                    <th>Action</th>
                                </tr>
                                <tr *ngFor="let p of persons; let i=index">
                                    <td>
                                        {{p.firstname}}
                                        {{p.othername}}
                                        {{p.surname}}
                                    </td>
                                    <td>
                                        {{p.phone}}
                                    </td>
                                    <td>
                                        {{p.email}}
                                    </td>
                                    <td>
                                        {{p.dob | date}}
                                    </td>

                                    <!-- <td>
                                        {{p.gender}}
                                    </td> -->

                                    <td>
                                        {{p.passportNo}}
                                    </td>
                                    <td>{{agee(p.dob) }} Years</td>
                                    <td>{{p.premium | currency:'₦ '}}</td>

                                    <td>
                                        <button class="delbtn" (click)="deleteE(p._id,i)">
                                            <span>delete</span>
                                            <!-- <mat-icon>delete</mat-icon> -->
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td style="font-size: 1.3rem; font-weight: bold;">Total:</td>
                                    <td style="font-size: 1.3rem; font-weight: bold; color: var(--primary-color);">
                                        {{grossDetail['grossPremium'] | currency:'₦ '}}</td>
                                    <td></td>
                                </tr>

                            </table>
                        </div>
                        <div class="flex" style="justify-content: end;">
                            <button mat-raised-button color="accent" style="font-weight: bold ;"
                                (click)="getDestination()">Next</button>
                        </div>
                    </div>


                </div>

            </div>
        </div>
        <div *ngIf="status" style="padding:20px 50px">
            <h2>Travel Summary</h2>
            <hr>
            <br>
            <div class="flex" style="justify-content: start;padding-right: 30px;">
                <div class="detailsBox sMbdrRad" style="width:100%;">
                    <h1>Travel Details</h1>
                    <br>
                    <div class="flex">
                        <div class="flex fg" style="flex: 1;">
                            <div style="flex: 1;">
                                <p>Destination</p>
                                <h3>{{grossDetail['countryName']}}</h3>
                            </div>
                            <div style="flex: 1;">
                                <p>Package</p>
                                <h3>{{grossDetail['categoryName']}}</h3>
                            </div>
                            <!-- <div style="flex:1;">
                                <p>Gross Premium</p>
                                <h3 style="color: var(--secondary-color);">{{grossDetail['grossPremium']}}</h3>
                            </div> -->
                        </div>

                        <div style="flex: 1;">
                            <!-- <h3 style="color: var(--secondary-color);">Duration of Cover</h3> -->
                            <div class="flex fg">
                                <div style="flex: 1;">
                                    <p>Start Date</p>
                                    <h3>{{grossDetail['startDate'] | date}}</h3>

                                </div>
                                <div style="flex: 1;">
                                    <p>End Date</p>
                                    <h3>{{grossDetail['endDate'] | date}}</h3>
                                </div>
                                <div style="flex: 1; text-align: center;">
                                    <p>Number of Days</p>
                                    <h3>{{grossDetail['numberOfDay'] | number}}</h3>
                                </div>
                            </div>

                        </div>
                        <!-- <div style="flex: 1;">

                            </div> -->
                    </div>
                </div>

            </div>
            <br>
            <h2 style="color: var(--secondary-color);padding-left: 10px;">Travellers</h2>
            <br>
            <div class="wrapper">
                <div *ngFor="let person of persons">
                    <div class="detailsBox sMbdrRad">
                        <h3 style="color: var(--secondary-color);">{{person['firstname'] | titlecase}}
                            {{person['othername'] | titlecase}} {{person['surname'] | titlecase}}</h3>
                        <br>
                        <div class="flex fg">
                            <div style="flex: 1;">
                                <p>Phone No.</p>
                                <h3>{{person['phone']}}</h3>
                            </div>
                            <div style="flex: 1;">
                                <p>Email</p>
                                <h3>{{person['email'] | titlecase}}</h3>
                            </div>

                        </div>
                        <br>
                        <div>
                            <div class="flex fg">
                                <div style="flex: 1;">
                                    <p>Gender</p>
                                    <h3>{{person['gender'] }}</h3>

                                </div>
                                <div style="flex: 1;">
                                    <p>DOB</p>
                                    <h3>{{person['dob'] | date}}</h3>
                                </div>
                            </div>

                        </div>
                        <br>
                        <div>
                            <div class="flex fg">
                                <div style="flex: 1;">
                                    <p>Premium</p>
                                    <h3>{{person['premium'] | currency:'₦ '}}</h3>

                                </div>
                                <div style="flex: 1;">
                                    <p>Passport Number</p>
                                    <h3>{{person['passportNo']}}</h3>
                                </div>
                            </div>
                        </div>
                        <br>
                        <div>
                            <div class="flex fg">
                                <div style="flex: 1;">
                                    <p>Passport Issue Date</p>
                                    <h3>{{person['passportIssueDate'] | date}}</h3>

                                </div>
                                <div style="flex: 1;">
                                    <p>Passport Expiry Date</p>
                                    <h3>{{person['passportExpiryDate'] | date}}</h3>
                                </div>
                            </div>
                        </div>
                        <br>
                        <div>
                            <div class="flex fg">
                                <div style="flex: 1;">
                                    <a href="{{person['passportDataPage']}}" target="_blank">
                                        <button class="passportBtn">
                                            View Passport Data Page
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <br>
            <div>
                <div>
                    <div>
                        <div class="flex tds">
                            <div style="flex:1;">
                                <p>Gross Premium</p>
                                <h3>{{grossDetail['grossPremium'] | currency:'₦ '}}</h3>
                            </div>
                            <div style="flex:1;">
                                <p>Net Premium</p>
                                <h3>{{(calcNet(grossDetail['grossPremium'])) | currency:'₦ '}}</h3>
                            </div>
                            <div style="flex:1;">
                                <p>Percentage</p>
                                <h3>20%</h3>
                            </div>
                            <div style="flex:1;">
                                <p>Commission</p>
                                <h3>{{calcCommission(grossDetail['grossPremium']) | currency:'₦ ' }}</h3>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <br>
            <div class="flex pad" style="justify-content: end;">

                <button mat-stroked-button (click)="status =!status" style="margin-right: 20px;">
                    <mat-icon class="mat-18">edit</mat-icon> Edit</button>
                <button mat-raised-button (click)="makePyt()" style="font-weight: bold;" color="accent">Proceed to
                   <mat-icon class="mat-18">arrow_forward</mat-icon>  Pay</button>
                <!-- <button ></button> -->
            </div>
        </div>
    </div>
</section>